import { PickType } from '@nestjs/swagger';
import { BoardFloorDto } from '../../board-floor/dto/board-floor.dto';
import { BoardExcelFloorBaseInterface } from '../interfaces/board-excel-floor-base.interface';

export class BoardExcelFloorBaseDto
  extends PickType(BoardFloorDto, [
    'floor',
    'quantity',
    'boardTypeId',
    'boardType',
  ])
  implements BoardExcelFloorBaseInterface {}
